import { render, staticRenderFns } from "./Repayment.vue?vue&type=template&id=656b3554"
import script from "./Repayment.vue?vue&type=script&lang=ts"
export * from "./Repayment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports